export default "__VITE_ASSET__D4TOo6jM__"